import { render, staticRenderFns } from "./PressRecent.vue?vue&type=template&id=8c8304d2&lang=pug&"
import script from "./PressRecent.vue?vue&type=script&lang=js&"
export * from "./PressRecent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports